import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class DataService {

  constructor() { }

  private Data: any;

  setData(data: any) {
    localStorage.setItem('data', JSON.stringify(data));
  }

  getData() {
    const storedData = localStorage.getItem('data');
    return storedData ? JSON.parse(storedData) : null;
  }
}
